import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "dubal_token";

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CONTACTS = {
  instagram: { handle: "@dubal.esportes", url: "https://instagram.com/dubal.esportes" },
  felipe: { name: "Felipe", number: "48 9 9951 0417", url: "https://wa.me/5548999510417" },
  villalobos: { name: "Villalobos", number: "48 9 9981 5209", url: "https://wa.me/5548999815209" },
};

export const PIX = {
  key: "48 9 9951 0417",
  holder: "Felipe Dubal Martins",
  warning: "Quadra apenas será reservada após confirmação de pagamento.",
};

export const NOTIFY_WHATSAPP = "5548999815209"; // Villalobos

export function brl(v) {
  return `R$ ${Number(v).toLocaleString("pt-BR")}`;
}

export function spaceImageUrl(space) {
  if (space?.custom_image) {
    return `${API}/spaces/${space.id}/image?v=${encodeURIComponent(space.image_updated_at || "")}`;
  }
  return space?.image;
}

export const HELP_WHATSAPP_URL = "https://wa.me/5548999815209"; // 48 9 9981 5209

export function barImageUrl(p) {
  if (p?.has_image) return `${API}/bar/products/${p.id}/image?v=${encodeURIComponent(p.image_updated_at || "")}`;
  return null;
}

export function waLink(phone) {
  let d = String(phone || "").replace(/\D/g, "");
  if (!d) return null;
  if (d.length <= 11) d = `55${d}`;
  return `https://wa.me/${d}`;
}

export const phoneValid = (p) => String(p || "").replace(/\D/g, "").length >= 10;

export const BUTTON_DEFAULTS = {
  reservas_title: "Reservaí Dubal", reservas_sub: "Aluguel de quadra",
  dayuse_title: "DayUse / Rotativo", dayuse_sub: "Jogo aberto e ranking",
  bar_title: "Bar e Cardápio", bar_sub: "Bebidas e petiscos",
  torneio_title: "Torneio", torneio_sub: "Inscrições, tabela e ranking",
  instagram_title: "Instagram", instagram_sub: "@dubal.esportes",
  help_title: "Preciso de Ajuda", help_sub: "WhatsApp (48) 9 9981-5209",
};

export const PAGE_TEXT_DEFAULTS = {
  login_title: "Bem-vindo à Dubal Esportes",
  login_subtitle: "Entre com o Google para reservar quadras, participar do DayUse e pedir no bar.",
  login_note: "Após o primeiro acesso, o administrador aprova sua conta para liberar reservas e compras.",
  reservas_tagline: "Esporte, movimento e energia sem igual.",
  reservas_section_title: "Escolha um espaço",
  dayuse_kicker: "Dubal Esportes",
  dayuse_title: "DAYUSE",
  dayuse_title_accent: "/ROTATIVO",
  dayuse_subtitle: "Jogo rotativo aberto. Confirme sua presença e venha jogar!",
  dayuse_ranking_title: "REI DO DAYUSE",
  dayuse_ranking_subtitle: "Os campeões de cada edição.",
  dayuse_games_title: "Jogos ao vivo",
  dayuse_confirmed_title: "CONFIRMADOS DAYUSE/ROTATIVO",
  dayuse_inactive_title: "Nenhum DayUse ativo no momento",
  dayuse_inactive_subtitle: "Fique de olho no nosso Instagram para a próxima edição!",
  bar_title: "Bar Dubal Esportes",
  bar_subtitle: "Peça bebidas e petiscos sem sair da quadra.",
};

export const PERM_LABELS = {
  reservas: "Reservas & Faturamento", agenda: "Agenda do mês", usuarios: "Usuários (aprovar e editar)",
  cargos: "Alterar cargos (admin/subadmin)", vendas: "Vendas do Bar e Comandas", produtos: "Cadastro de Produtos",
  estoque: "Estoque", horarios: "Controle de Horários", midia: "Logos, Imagens, Vídeos e Banners",
  textos: "Textos das Páginas", dayuse: "DayUse, Ranking e Jogos", torneio: "Torneios", excluir: "Excluir registros",
};

export const ROLE_LABELS = { admin: "Admin", subadmin: "Subadmin", bar: "Bar", professor: "Professor", admin_torneio: "Admin Torneio" };
export const STAFF_ROLES = Object.keys(ROLE_LABELS);

export const can = (user, perm) => !!user?.perms?.includes(perm);

export const mediaUrl = (p) => (p && p.startsWith("/api") ? `${BACKEND_URL}${p}` : p || null);

export function userPhotoUrl(u) {
  if (u?.has_photo) return `${API}/users/${u.user_id}/photo?v=${encodeURIComponent(u.photo_updated_at || "")}`;
  return u?.picture || null;
}
